/* eslint-disable camelcase */
import { NoteType } from '@/@types/note';
import { useRouter } from 'next/router';
import React, { useState } from 'react';

export type NoteTypeFilter = NoteType | 'all';

export function useNotesFilters() {
  const router = useRouter();
  const {
    search = '',
    sort = 'desc',
    sort_by = 'created_at',
    deleted,
    type = '',
    page = 1,
    per_page = 25,
  } = router.query;
  const [tempSearch, setTempSearch] = useState(search as string);
  const [showDeleted, setShowDeleted] = useState(deleted === 'true');
  const [tempType, setTempType] = useState<NoteTypeFilter>(
    (type as NoteType) || 'all'
  );

  const handleFilter = () => {
    router.replace({
      query: {
        page: 1,
        search: tempSearch,
        sort,
        sort_by,
        deleted: showDeleted,
        per_page,
        ...(tempType !== 'all' ? { type: tempType } : {}),
      },
    });
  };

  const handleClearFilters = () => {
    router.replace('/notes');
    setTempSearch('');
    setShowDeleted(false);
    setTempType('all');
  };

  const handlePageChange = (newPage: number) => {
    router.replace({ query: { ...router.query, page: newPage + 1 } });
  };

  const handlePerPageChange = (newPerPage: number) => {
    router.replace({ query: { ...router.query, per_page: newPerPage } });
  };

  const handleSort = (column: string) => {
    router.replace({
      query: {
        ...router.query,
        sort: sort === 'asc' ? 'desc' : 'asc',
        sort_by: column,
      },
    });
  };

  const handleShowDeletedChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => setShowDeleted(event.target.checked);

  return {
    search: search as string,
    sort: sort as 'asc' | 'desc',
    sortBy: sort_by as string,
    deleted: deleted === 'true',
    type: (type as NoteType) || undefined,
    page: Number(page),
    perPage: Number(per_page),
    tempSearch,
    tempType,
    showDeleted,
    setTempSearch,
    setTempType,
    setShowDeleted,
    handleFilter,
    handleClearFilters,
    handlePageChange,
    handlePerPageChange,
    handleSort,
    handleShowDeletedChange,
  };
}
